import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewEncapsulation, ViewChild } from '@angular/core';
import {DemoService} from '../../../../demo.service';
// import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../../services/mysql.service';

// import {CurrentsDataSourceComponent} from '../../../../views/appviews/currents-data-source/currents-data-source.component';
import { Job } from '../../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// // import { Observable } from 'rxjs/Observable'; // this created errors ats use below
// import {Observable, Subject} from 'rxjs';
// 
// import { Subscription } from 'rxjs';
// 
// 
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { JobSubject } from './../../../../shared/models/jobSubject.model';

@Component({
  selector: 'app-subject-nav-bar',
  templateUrl: './subject-nav-bar.component.html',
  styleUrls: ['./subject-nav-bar.component.css'],
})
export class SubjectNavBarComponent implements OnInit {
  currentUserVAR: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  sessionUserLevel: any;
  brand_id: any;
  subject_id: number;
  subjects: Object;

  model: JobSubject;

  job_id: any;
  file_number: any;
  subject_number: any;
  job_type_id: any;
  job_type_location_id: any;
  job_type_court_id: any;
  job_type_document_type_id: any;
  job_type_affidavit_type_id: any;

  public dropdown_data: string[] = ['Snooker', 'Tennis', 'Cricket', 'Football', 'Rugby'];
  job_subjects: any;
  all_router_details: string;

  constructor(private route: ActivatedRoute, private router: Router,
    public _demoService: DemoService,
    vcr: ViewContainerRef,
    private _mysqlService: MysqlService,
    public gfunc: GlobalFunctionsService ) {

    // Changed so that redirects do not throw errors.
    this.subject_id = +this.route.snapshot.paramMap.get('subject_id');

// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

// need to add this as routes does not work globally
this.all_router_details = this.router.url;
this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

this.brand_id = this.sessionBrandId;
// this.toastr.setRootViewContainerRef(vcr);
   }

  ngOnInit() {


    if (+this.route.snapshot.paramMap.get('subject_id') !== null) {
      this.getJobSubject(this.subject_id);
    }

  }




  
  subjectView2(subject_id) {
      
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']));
    
    // this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
    this.gfunc.globalJobSubjectCardSkipRoute(subject_id);
  
  
    // works but does not refresh the page only if set up as a listner.
  // this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
 }



   
 subjectViewCardLayoutsDashboard(subject_id) {
      
  // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  // this.router.navigate(['/admin/jobs/subject/edit/' + subject_id + '']));
  
  // this.gfunc.globalJobSubjectViewSkipRoute(subject_id);
  this.gfunc.globalJobSubjectCardLayoutsDashboardSkipRoute(subject_id);


  // works but does not refresh the page only if set up as a listner.
// this.router.navigate(['../'  + subject_id], { relativeTo: this.route });
}

 jobView(job_id) {
  // this.router.navigate(['/admin/jobs/view/' + job_id + '']);
  this.gfunc.globalJobViewSkipRoute(job_id);
}


subjectCommunication(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/communication/' + subject_id + '']);
  this.gfunc.globalJobSubjectCommunicationViewSkipRoute(subject_id);
}

subjectCommunicationWithVars(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/communication/' + subject_id + '']);
  this.gfunc.globalJobSubjectCommunicationWithVarsViewSkipRoute(subject_id);
}

subjectDocuments(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/documents/' + subject_id + '']);
  this.gfunc.globalJobSubjectDocumentsViewSkipRoute(subject_id);
}

subjectNotesTab(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/notes/' + subject_id + '']);
  this.gfunc.globalJobSubjectNotesViewSkipRoute(subject_id);
}


subjectAttendanceTab(subject_id) {
  this.router.navigate(['/admin/jobs/subject/attendance/' + subject_id + '']);
}


subjectBillingTab(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/billing/' + subject_id + '']);
  this.gfunc.globalJobSubjectBillingViewSkipRoute(subject_id);
}

subjectCostTab(subject_id) {
  // this.router.navigate(['/admin/jobs/subject/cost/' + subject_id + '']);
  this.gfunc.globalJobSubjectCostViewSkipRoute(subject_id);
}


getJobSubject(subject_id) {
  this._demoService.getJobSubject(subject_id).subscribe(
     data => { this.subjects = data;
      const res = data[0];

      this.job_id = res.job_id;
      this.file_number = res.file_number;
      this.subject_number = res.subject_number;

      this.job_type_id = res.job_type_id;
      this.job_type_location_id = res.job_type_location_id;
      this.job_type_court_id = res.job_type_court_id;
      this.job_type_document_type_id = res.job_type_document_type_id;
      this.job_type_affidavit_type_id = res.job_type_affidavit_type_id;

      this.getJobSubjects(res.job_id);

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );

 } // end function




 getJobSubjects(job_id) {
  this._demoService.getJobSubjects(job_id).subscribe(
     data => { this.job_subjects = data;
      const res = data[0];

      // this.job_id = res.job_id;
      // this.file_number = res.file_number;
      // this.subject_number = res.subject_number;

      // this.job_type_id = res.job_type_id;
      // this.job_type_location_id = res.job_type_location_id;
      // this.job_type_court_id = res.job_type_court_id;
      // this.job_type_document_type_id = res.job_type_document_type_id;
      // this.job_type_affidavit_type_id = res.job_type_affidavit_type_id;

    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );

 } // end function


}
